import React, { Component } from 'react';
import { MultiSelect } from 'primereact/components/multiselect/MultiSelect';
import { styles } from './Multiselect.styles';
import { getDefaultPermissions } from '../../../constants/perms';

class Multiselect extends Component {
  state = {
    options: []
  };

  componentDidMount() {
    if (this.props.value) {
      this.setState({ options: getDefaultPermissions(this.props.value) });
    }
  }

  handleSelection = e => {
    this.setState({ options: e.value });
    this.props.onChange(e.value);
  };

  render() {
    const { options, placeholder, ...rest } = this.props;
    return (
      <MultiSelect
        {...rest}
        value={this.state.options}
        options={options}
        defaultLabel={placeholder}
        onChange={this.handleSelection}
        scrollHeight={'122px'}
        style={styles.multiselect}
        filter={true}
      />
    );
  }
}

export default Multiselect;



// WEBPACK FOOTER //
// ./src/components/inputs/multiselect/Multiselect.js